import posthog from "posthog-js";

import { analyticsEnabled } from "./enabled";

/** Ambient super property shared across the PostHog project — filter insights by this. */
export function registerEnvironmentSuperProperty() {
    if (!analyticsEnabled) return;
    posthog.register({ environment: import.meta.env.VITE_ENVIRONMENT });
}
